<template>
    <dl class="grid gap-x-4 gap-y-8 grid-cols-1 lg:grid-cols-2">
        <slot></slot>
    </dl>
</template>

<script>
export default {
    //
}
</script>
